// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        loadProductFirst: true
    },
  	template: {
      	filterOptionSwatchItem: '<li><a href="javascript:;" style="background-color: {{itemValue}}; background-image: url({{itemImageValue}}); border: {{itemBorder}}" data-id="{{itemParentId}}" data-value="{{itemValue}}" data-parent-label="{{itemParentLabel}}" title="{{itemValue}}" onClick="{{itemFunc}}" class="{{itemSelected}}"></a><span>{{itemValue}}</span></li>',
  	}
};

// Declare Templates
var bcSfFilterTemplate = {
    'productGridItemHtml': '<div class="item">' +
                                '{{itemNewLabel}}' +
                                '<div class="item-image">' +
                                    '<a href="{{itemUrl}}" class="item-buy">Customize Now</a>'+
                                    '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}" />' +
                                '</div>' +
                                '<a href="{{itemUrl}}" class="product-title">'+
                                '{{itemTitle}} '+
                                '</a>'+
                                '<div class="price">{{itemPrice}}</div>'+
                            '</div>' +
                            '{{itemNewRow}}',

    'previousHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
    'nextHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
  
    'sortingHtml': '<label>' + bcSfFilterConfig.label.sorting + '</label><select>{{sortingItems}}</select>',
    'showLimitHtml': '<label>' + bcSfFilterConfig.label.show_limit + '</label><select>{{showLimitItems}}</select>',

    'breadcrumbHtml': '<nav class="breadcrumb" role="navigation" aria-label="breadcrumbs"><a href="/" title="Back to the frontpage">Home</a><span aria-hidden="true" class="breadcrumb__sep">›</span><span>{{itemSelected}}</span></nav>'
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    // Prepare data
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100;
    var soldOut = !data.available;
    var onSale = data.compare_at_price_min > data.price_min;
    var priceVaries = data.price_min != data.price_max;

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Custom class
    var itemGridWidthClass = '';
    switch (bcSfFilterConfig.custom.products_per_row) {
        case 4: itemGridWidthClass = 'span3'; break;
        case 3: itemGridWidthClass = 'span4'; break;
        case 2: itemGridWidthClass = 'span6'; break;
    }
    itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

    // Sale labe
    var itemSaleLabelHtml = '';
    if (onSale && bcSfFilterConfig.custom.show_sale_circle) {
        itemSaleLabelHtml = '<span class="circle sale">Sale</span>';
    }
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

    // New label
    var itemNewLabelHtml = '';
    if (jQuery.inArray( "new", data.tags) > -1) {
        itemSaleLabelHtml = '<div class="new-label"><span>New</span></div>';
    }
    itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);

    // Add Thumbnail
    var images = Object.keys(data.images).map(function (key) { return data.images[key]; });
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]) : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? '<span class="vendor">{{itemVendor}}</span>': '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Price
    var itemPriceHtml = '';
    if (!soldOut) {
        if (data.compare_at_price_max > data.price_min) {
            itemPriceHtml += '<del>' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</del>';
        }
        if (priceVaries) {
            itemPriceHtml += '<small><em>from</em></small>';
        }
        itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);
    } else {
        itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat) + ' Sold Out';
    }
    if (data.collections) {
        var hatLabel = data.collections.filter(function(e) { return e.handle == 'hats'; });
        if (typeof hatLabel !== 'undefined') {
            itemPriceHtml += '';
        }
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add New row
    var itemNewRowHtml = '';
    itemHtml = itemHtml.replace(/{{itemNewRow}}/g, itemNewRowHtml);

    // Add main attribute
    console.log(data)
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemSku}}/g, data.skus[0]);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.bottomPagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousHtml : '';
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextHtml : '';
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Build page items
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, 'Page ' + currentPage + ' of ' + totalPage);

        jQ(this.selector.bottomPagination).html(paginationHtml);

        jQ('#bc-sf-filter-top-pagination-info').html('Page ' + currentPage + ' of ' + totalPage);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Breadcrumb when user select "Collection" filter option
BCSfFilter.prototype.buildBreadcrumb = function(data) {
    var breadcrumbHtml = bcSfFilterTemplate.breadcrumbHtml.replace(/{{itemSelected}}/g, data);
    jQ(this.selector.breadcrumb).html(breadcrumbHtml);
};

BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  this.buildRobotsMetaTag();}

function BCSfFilterCallback (result) {
	bcsffilter.hideLoading();
	bcsffilter.afterGetFilterData(result, result.event_type);
};

// Request API for Filter Data
BCSfFilter.prototype.getFilterData = function (eventType) {
	var _this = this;
	_this.showLoading();
	
	// Prepare params
	var params = mergeObject({}, this.queryParams);
	params.collection_scope = parseInt(this.collectionId);
	if (eventType == "history") {
		if (History.getState().data.hasOwnProperty("param") && History.getState().data.param.hasOwnProperty("collection_scope")) {
			params.collection_scope = this.collectionId = parseInt(History.getState().data.param.collection_scope);
		} else {
			params.collection_scope = this.collectionId = parseInt(bcSfFilterConfig.general.collection_id);
		}
	}
	if (this.getSettingValue("general.availableAfterFiltering") == true) {
		params.product_available = this.checkExistFilterOptionParam() === true ? true : this.productAvailable;
		params.variant_available = this.checkExistFilterOptionParam() === true ? true : this.variantAvailable;
	} else {
		params.product_available = this.productAvailable;
		params.variant_available = this.variantAvailable;
	}
	if (typeof this.collectionTags !== "undefined" && this.collectionTags !== null) {
		params.tag = this.collectionTags[0];
	}
	params.build_filter_tree = (typeof eventType !== "undefined" && this.imutableFilterTree.indexOf(eventType) > -1) ? false : true; // Except events of elements in filter tree, all remaining events do not rebuild filter tree
	params.check_cache = (this.checkExistFilterOptionParam() === false && params["page"] == 1 && params["sort"] == this.defaultSorting && params["limit"] == this.getSettingValue("general.limit")) ? true : false; // Only cache when request doest not have Refine By, "page" param equal to 1 and "sort" param equal to default sorting
	// Set data back to queryParams
	this.queryParams = params;

	this.queryParams["callback"] = "BCSfFilterCallback";
	this.queryParams["event_type"] = eventType;
	var script = document.createElement("script");
	//Set the Type
	script.type = "text/javascript";
	var timestamp = new Date().getTime();
	//Set the source to the URL the JSON Service.
	script.src = bcSfFilterConfig.shop.apiUrl + "?t=" + timestamp + "&" + jQ.param(_this.queryParams);
	script.async = true;
	script.addEventListener("error", function (e) {
		this.remove();
		// Error handling here 
		_this.showError("Oops, we cannot fetch products at this moment. Please try again later.");
	});
	//Append the script element to the HEAD section.
	document.getElementsByTagName("head")[0].appendChild(script);
	script.onload = function () {
		this.remove();
	};
};

// Customize data to suit the theme
BCSfFilter.prototype.prepareProductData = function(data) {
	for (var k in data) {
		var optionsArr = [];
		for (var i in data[k]["options_with_values"]) {
			optionsArr.push(data[k]["options_with_values"][i]["name"]);
		}
		data[k]["options"] = optionsArr;
		for (var i in data[k]["variants"]) {
			var variantOptionArr = [];
			var count = 1;
			var variant = data[k]["variants"][i];

		   // New API
			if (typeof variant.hasOwnProperty("merged_options")) {
				var variantOptions = variant["merged_options"];
				for (var j in variantOptions) {
				  var temp = variantOptions[j].split(":");
				  data[k]["variants"][i]["option" + (parseInt(j) + 1)] = temp[1];
				  data[k]["variants"][i]["option_" + temp[0]] = temp[1];
				  variantOptionArr.push(temp[1]);
				}
			}
			// Old API
			else {
				for (var j in variant) {
					if (j.indexOf("option_") != -1) {
					  data[k]["variants"][i]["option" + count] = variant[j];
					  variantOptionArr.push(data[k]["variants"][i][j]);
					  count ++;
					}
				}
			}
			data[k]["variants"][i]["compare_at_price"] = parseFloat(data[k]["variants"][i]["compare_at_price"]) * 100;
			data[k]["variants"][i]["price"] = parseFloat(data[k]["variants"][i]["price"]) * 100;
			data[k]["variants"][i]["options"] = variantOptionArr;
		}
	}
	return data;
};

function mergeObject(a, b) {
	for (var c in b) try {
		a[c] = b[c].constructor == Object ? mergeObject(a[c], b[c]) : b[c]
	} catch (d) {
		a[c] = b[c]
	}
	return a
}

BCSfFilter.prototype.afterGetFilterData = function(a, b) {
		a.hasOwnProperty("errorMessage") ? this.showError("Oops, we cannot fetch products at this moment. Please try again later.") : (a.total_product <= 0 && ("page" == b && "default" != this.getSettingValue("general.paginationType") || (this.hasFilterOptionParam === !1 ? jQ(this.selector.filterWrapper).length > 0 && (jQ(this.selector.topNotification).length > 0 ? jQ(this.selector.topNotification).html("<p>Sorry, there are no products in this collection. Please select other collection or go back to homepage.</p>") : jQ(this.selector.filterWrapper).before('<div id="' + this.selector.topNotification + '"><p>Sorry, there are no products in this collection. Please select other collection or go back to homepage.</p></div>'), jQ(this.selector.filterWrapper).hide(), jQ(this.selector.filterTree).html(""), jQ(this.selector.filterTreeMobileButton).html(""), jQ(this.getSelector("products")).html("")) : jQ(this.getSelector("products")).html("<p>Sorry, no products matched your selection.</p>"), jQ(this.selector.bottomPagination).html(""), jQ(this.selector.topShowLimit).html(""), jQ(this.selector.topSorting).html(""))), this.buildAll(a, this.queryParams.build_filter_tree, b))
}
/* boost-start-2.4.2 */
/* If you upgrade the lib to the version >= 2.4.2, please comment the functions below out */
BCSfFilter.prototype.buildRobotsMetaTag = function(data) { var self = this; var metaContent = 'meta[content="noindex,nofollow"]'; if (self.checkIfPFParamsPartOfAURL() === true && jQ('head').find( metaContent).length === 0) { var m = document.createElement('meta'); m.name = 'robots'; m.content = 'noindex,nofollow'; document.head.appendChild(m); } }; BCSfFilter.prototype.checkIfPFParamsPartOfAURL = function() { var self = this; if (window.location.search.length > 0 && window.location.search.indexOf('pf_') > 0) { return true; } return false; };
/* boost-end-2.4.2 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
